import { ButtonGroup, Button, Card } from '@/components'
import { MouseEvent, useEffect, useState } from 'react'
import { KeyboardArrowUp } from '@mui/icons-material'

function SeeMore ( props: SeeMoreProps ) {
    const {
        defaultShowCount, totalList, marginTop = '8px', marginBottom = '8px',
        setShowCount: propsSetShowCount,
        onClick,
        ...rest
    } = props
    const [ showCount, setShowCount ] = useState( defaultShowCount )
    const [ isSeeMore, setIsSeeMore ] = useState( false )
    const hideCount = totalList.length < showCount ? 0 : totalList.length - showCount

    useEffect( () => {
        hideCount === 0 && setIsSeeMore( true )
        propsSetShowCount( showCount )
    }, [
        hideCount,
        propsSetShowCount,
        showCount
    ] )

    const moveScrollTop = () => {
        const rootElement = document.getElementById( 'root' )
        const { scrollTop = 0 } = rootElement || {}

        if ( rootElement && scrollTop > 0 ) {
            window.requestAnimationFrame( moveScrollTop )
            rootElement.scrollTop = scrollTop - scrollTop / 4
        }
    }
    const onCustomClick = ( e: MouseEvent<HTMLButtonElement> ) => {
        onClick && onClick( showCount )
        setShowCount( showCount + defaultShowCount )

        e.preventDefault()
    }

    return (
        <Card sx={ { marginTop, marginBottom } }>
            <ButtonGroup
                fullWidth
                disableElevation
                variant="contained"
            >
                <Button
                    { ...rest }
                    disabled={ isSeeMore }
                    onClick={ ( e ) => { onCustomClick( e ) } }
                >
                    <span style={ {
                        overflow: 'hidden',
                        outline: 'none',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    } }>{ `${ hideCount < defaultShowCount ? hideCount : defaultShowCount }개 더보기 ( ${ hideCount }/${ totalList.length } ) ` }</span>
                </Button>
                <Button
                    sx={ { width: '90px' } }
                    startIcon={ <KeyboardArrowUp/> }
                    onClick={ () => { moveScrollTop() } }
                >
                    <span style={ { whiteSpace: 'nowrap', } }>맨 위</span>
                </Button>
            </ButtonGroup>
        </Card>
    )
}

export default SeeMore

export interface SeeMoreProps {
    defaultShowCount: number
    totalList: Record<string, any>[]
    marginTop?: string | number
    marginBottom?: string | number
    onClick?: ( showCount: number ) => void
    setShowCount: ( showCount: number ) => void
}